export default __webpack_public_path__ + "static/media/vajrada_amethyst_gemstone.b74e703c.png";